<template>
  <div v-if="nonMemberInfo">
    <table class="board-write type-block--mobile">
      <caption>
        개인정보작성
      </caption>
      <tbody>
        <!-- 성명 -->
        <tr>
          <th scope="row"><span class="u-color-red">* </span>성명</th>
          <td>
            <label for="userName" class="sr-only">성명</label>
            <div class="layout-flex-row">
              <input
                ref="userNameRef"
                v-model="nonMemberInfo.userName"
                type="text"
                id="userName"
                placeholder=""
                class="board-write__input"
              />
            </div>
          </td>
        </tr>
        <!-- 영문명 -->
        <tr>
          <th scope="row"><span class="u-color-red">* </span>영문명</th>
          <td>
            <label for="userEngName" class="sr-only">영문명</label>
            <input
              ref="userEngNameRef"
              v-model="nonMemberInfo.userEngName"
              type="text"
              id="userEngName"
              placeholder=""
              class="board-write__input"
            />
          </td>
        </tr>
        <!-- 이메일 -->
        <tr>
          <th scope="row"><span class="u-color-red">* </span>이메일</th>
          <td>
            <label for="email" class="sr-only">이메일</label>
            <input
              ref="emailRef"
              v-model="nonMemberInfo.email"
              type="text"
              id="email"
              placeholder=""
              class="board-write__input"
            />
          </td>
        </tr>
        <!-- 연락처 -->
        <tr>
          <th scope="row"><span class="u-color-red">* </span>연락처</th>
          <td>
            <label for="phone" class="sr-only">연락처</label>
            <input
              ref="phoneRef"
              v-model="nonMemberInfo.phone"
              type="text"
              id="phone"
              placeholder=""
              class="board-write__input"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <section class="section-accordion__wrap type-bullet type-top-narrow">
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >개인정보 수집 이용/취급위탁 동의(필수항목)</span
            >
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                한국인터넷진흥원은 보안 취약점 신고포상제 서비스 제공을 위해
                필요한 최소한의 개인정보만을 수집·이용합니다.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. 개인정보 수집 및 이용 목적
                </li>
                <li class="section-accordion__desc">- 보안 취약점 신고 접수</li>
                <li class="section-accordion__desc">
                  - 신고포상제 운영 및 포상금 지급
                </li>
                <li class="section-accordion__desc">
                  2. 수집하려는 개인정보의 항목
                </li>
                <li class="section-accordion__desc">
                  - 필수 정보 : 성명, 영문명, 이메일, 연락처
                </li>
                <li class="section-accordion__desc">
                  3. 개인정보의 보유 및 이용기간 : 1년
                </li>
                <li class="section-accordion__desc">
                  ※ 위 개인정보의 수집·이용 및 취급위탁을 거부할 수 있으며, 이
                  경우 보안 취약점 신고포상제 서비스 이용이 제한됩니다.
                </li>
              </ol>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                개인정보 수집/이용에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    ref="privateYnTmpRef"
                    type="radio"
                    name="privateYnTmp"
                    v-model="nonMemberInfo.privateYnTmp"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    ref="privateYnTmpRef"
                    type="radio"
                    name="privateYnTmp"
                    v-model="nonMemberInfo.privateYnTmp"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            aria-controls="panel-1"
            id="accordion-trigger-1"
          >
            <span class="section-accordion__num" aria-hidden="true"></span>
            <span class="section-accordion__title"
              >개인정보 수집 이용/취급위탁 동의(선택항목)
            </span>
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
        >
          <div
            class="section-accordion__content section-accordion__agree__wrap"
          >
            <div class="section-accordion__agree__inner">
              <p class="section-accordion__desc">
                한국인터넷진흥원은 보안 취약점 신고포상제 서비스 제공을 위해
                필요한 최소한의 개인정보만을 수집·이용합니다.
              </p>
              <ol>
                <li class="section-accordion__desc">
                  1. 개인정보 수집 및 이용 목적
                </li>
                <li class="section-accordion__desc">- 기념품 지급</li>
                <li class="section-accordion__desc">
                  2. 수집하려는 개인정보의 항목
                </li>
                <li class="section-accordion__desc">- 선택 정보 : 소속</li>
                <li class="section-accordion__desc">
                  3. 개인정보의 보유 및 이용기간 : 1년
                </li>
                <li class="section-accordion__desc">
                  ※ 위 개인정보의 수집·이용 및 취급위탁을 거부할 수 있으며,
                  기념품 지급이 제한됩니다.
                </li>
              </ol>
            </div>
            <div class="section-accordion__agree">
              <p class="section-accordion__agree__desc">
                개인정보 수집/이용에 동의합니다.
              </p>
              <div class="chk__wrap">
                <label class="chk chk--circle">
                  <input
                    ref="privateYnRewardRef"
                    type="radio"
                    name="privateYnReward"
                    v-model="nonMemberInfo.privateYnReward"
                    :value="false"
                  />동의안함
                </label>
                <label class="chk chk--circle">
                  <input
                    ref="privateYnRewardRef"
                    type="radio"
                    name="privateYnReward"
                    v-model="nonMemberInfo.privateYnReward"
                    :value="true"
                  />동의함
                </label>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
    <div class="btn__wrap type-bottom-board">
      <button
        type="button"
        class="btn btn--l btn--blue"
        @click="triggerClickToTab()"
      >
        다음
        <span aria-hidden="true"
          ><img src="@/assets/img/icon_arrow_right.svg" alt=""
        /></span>
      </button>
    </div>
  </div>
</template>

<script>
import reportHandler from "../../ReportHandler.js";
import { ref, inject, watch } from "vue";

export default {
  props: {
    modelValue: { type: Object, required: true },
  },
  setup(props, { emit }) {
    const lodash = inject("lodash");
    // data 정의
    const nonMemberInfo = ref(lodash.cloneDeep(props.modelValue.personal));

    // 각 입력 필드 ref 선언 (포커스용)
    const userNameRef = ref(null);
    const userEngNameRef = ref(null);
    const emailRef = ref(null);
    const phoneRef = ref(null);
    const privateYnTmpRef = ref(null);
    const privateYnRewardRef = ref(null);
    const privateThirdYnRef = ref(null);

    // methods 정의
    const triggerClickToTab = () => {
      const result = reportHandler.triggerClickToTabDomestic(
        1,
        nonMemberInfo.value
      );
      if (typeof result === "string") {
        focusInput(result);
        return;
      }
      emit("changeTab", 1);
    };
    const focusInput = (key) => {
      // 입력 포커스 기능
      const refMap = {
        userName: userNameRef,
        userEngName: userEngNameRef,
        email: emailRef,
        phone: phoneRef,
        privateYnTmp: privateYnTmpRef,
        privateThirdYn: privateThirdYnRef,
      };

      const refObj = refMap[key];
      if (refObj && refObj.value) {
        refObj.value.focus();
      }
    };

    // watch 정의
    watch(
      nonMemberInfo,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          personal: newVal,
        });
      },
      { deep: true }
    );

    // html에서 사용될 데이터 정의
    return {
      nonMemberInfo,
      triggerClickToTab,
      focusInput,
      userNameRef,
      userEngNameRef,
      emailRef,
      phoneRef,
      privateYnTmpRef,
      privateYnRewardRef,
      privateThirdYnRef,
    };
  },
};
</script>

<style>
.red-text {
  color: #ff0000;
}
</style>